var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotifiaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66983 19.875H14.3253C14.1923 20.6614 13.7852 21.3752 13.176 21.89C12.5669 22.4048 11.7951 22.6872 10.9976 22.6872C10.2 22.6872 9.42827 22.4048 8.81913 21.89C8.20998 21.3752 7.80281 20.6614 7.66983 19.875ZM10.9976 0.75C13.2353 0.75 15.3815 1.63895 16.9638 3.22129C18.5461 4.80362 19.4351 6.94974 19.4351 9.1875V13.6875L21.0303 17.2425C21.1029 17.4051 21.1336 17.5832 21.1198 17.7607C21.106 17.9382 21.0481 18.1095 20.9513 18.2589C20.8545 18.4083 20.7219 18.5312 20.5656 18.6164C20.4093 18.7016 20.2341 18.7463 20.0561 18.7466H1.94358C1.7653 18.7466 1.58986 18.702 1.43324 18.6168C1.27662 18.5317 1.14378 18.4087 1.04684 18.2591C0.949891 18.1094 0.891911 17.938 0.878177 17.7602C0.864442 17.5825 0.89539 17.4041 0.968202 17.2414L2.56008 13.6864V9.17287L2.5657 8.89162C2.64266 6.70671 3.5647 4.63696 5.13756 3.11845C6.71043 1.59994 8.81131 0.750103 10.9976 0.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifiaction);
export default __webpack_public_path__ + "static/media/icon-notifiaction.f84d1b3cfd7f8ac6b2e05a846c98aa62.svg";
export { ForwardRef as ReactComponent };